import { Show, SignIn } from '@clerk/react';
import { useSearch } from '@tanstack/react-router';
import { useEffect } from 'react';

import { sanitizeReturnTo, signInDoneUrl } from '@/auth/roleDecision';

export function SignInPage() {
  // The deep link the signed-out user was headed to (written by RoleGuard).
  // Threaded through Clerk's redirect URL so /sign-in/done can finish the
  // round trip after authentication.
  const { redirect } = useSearch({ strict: false }) as { redirect?: string };
  const doneUrl = signInDoneUrl(sanitizeReturnTo(redirect ?? null));
  return (
    <div className="grid gap-6">
      <Show when="signed-in">
        {/* Should never render — `/sign-in/done` handles the post-sign-in
            dispatch — but if the user navigates here while already signed
            in, send them on. */}
        <PostSignInRedirect doneUrl={doneUrl} />
      </Show>
      <Show when="signed-out">
        <div className="mx-auto max-w-md">
          <SignIn
            routing="hash"
            signUpUrl="/sign-in"
            forceRedirectUrl={doneUrl}
            signUpForceRedirectUrl={doneUrl}
          />
        </div>
      </Show>
    </div>
  );
}

function PostSignInRedirect({ doneUrl }: { doneUrl: string }) {
  // Bounce signed-in users to the dispatch route; that route handles
  // the practitioner-vs-customer split. Navigation runs in useEffect so
  // render stays pure under React 19 / StrictMode.
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace(doneUrl);
    }
  }, [doneUrl]);
  return null;
}
